

export function RouteUndefined() {
    return(
        <h1 style={{color: "var(--colorButton)"}}>404 not found</h1>
    )
}